<template>
  <div id="app">
    <Navbar/>
    <router-view></router-view>
  </div>
</template>

<script>

import Navbar from "@/components/NavBar"
import store from "@/store/store";
import router from "@/router";

export default {
  name: 'AppRoot',
  components:{
    Navbar,
  },
  beforeMount() {
    if (!store.getters.getIsLoggedIn) {
      router.push({name: 'Login'})
    }
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--dark);
}

.navbar.navbar-dark.bg-dark{
  background-color: var(--primary) !important;
}

.border-secondary {
    border-color: var(--secondary) !important;
}

.border-light {
    border-color: var(--light)!important;
}

.text-secondary {
    color: var(--secondary) !important;
}

.btn-outline-primary {
        color: var(--primary);
        border-color: var(--primary)
}

.btn-outline-primary:hover {
        color: #fff;
        background-color: var(--primary);
        border-color: var(--primary)
}

.btn-outline-primary.focus,
.btn-outline-primary:focus {
        box-shadow: 0 0 0 .2rem rgba(16, 24, 32, .5)
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
        color: var(--primary);
        background-color: transparent
}

.btn-outline-primary:not(:disabled):not(.disabled).active,
.btn-outline-primary:not(:disabled):not(.disabled):active,
.show>.btn-outline-primary.dropdown-toggle {
        color: #fff;
        background-color: var(--primary);
        border-color: var(--primary)
}

.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.show>.btn-outline-primary.dropdown-toggle:focus {
        box-shadow: 0 0 0 .2rem rgba(16, 24, 32, .5)
}

.btn-primary {
    color: #fff;
    background-color: var(--primary);
    border-color: var(--primary);
}

.btn-primary.focus, .btn-primary:focus, .btn-primary:hover {
    color: #fff;
    background-color: var(--primary);
    border-color: var(--primary);
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show>.btn-primary.dropdown-toggle {
	color: #fff;
	background-color: var(--primary);
	border-color: var(--primary);
}

.btn-primary.disabled,
.btn-primary:disabled {
	color: #fff;
	background-color: var(--primary);
	border-color: var(--primary)
}

.btn-secondary {
    color: #fff;
    background-color: var(--secondary);
    border-color: var(--secondary);
}

.btn-secondary.focus, .btn-secondary:focus, .btn-secondary:hover {
    color: #fff;
    background-color: var(--secondary);
    border-color: var(--secondary);
}

.btn-secondary:not(:disabled):not(.disabled).active,
.btn-secondary:not(:disabled):not(.disabled):active,
.show>.btn-secondary.dropdown-toggle {
	color: #fff;
	background-color: var(--secondary);
	border-color: var(--secondary);
}

.btn-secondary.disabled,
.btn-secondary:disabled {
	color: #fff;
	background-color: var(--secondary);
	border-color: var(--secondary)
}

.bg-primary {
    background-color: var(--primary)!important;
}

.bg-secondary {
    background-color: var(--secondary)!important;
}

.text-primary {
    color: var(--primary)!important;
}

.text-secondary {
    color: var(--secondary)!important;
}

.text-light {
    color: var(--light)!important;
}

.text-dark {
    color: var(--dark)!important;
}

.input-group-text {
  color: var(--dark);
}

</style>